module.exports = flarum.core.compat['components/ReplyComposer'];